import React, { useEffect, useState } from "react";

import moment from "moment";
import Modal from "../Modal";

import { IconCalendar } from "./IconCalendar";
import { IconChevronLeft } from "./IconChevronLeft";
import { IconChevronRight } from "./IconChevronRight";

import styles from "./calendar.module.css";

const dayNames = ["L", "M", "X", "J", "V", "S", "D"];
const monthNames = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

const genCalendar = (month, year) => {
  const date = moment(new Date(year, month, 1));
  const dayOfWeekStart = date.day() === 0 ? 6 : date.day() - 1;

  const days = Array(dayOfWeekStart).fill(null);

  for (let day = 0; day < date.daysInMonth(); day++) {
    days.push(String(day + 1));
  }

  return { days };
};

const initialState = {
  year: moment().year(),
  month: moment().month(),
  day: null,
};

const CustomCalendar = ({
  isOpen,
  value = moment(),
  onClose = () => {},
  onClear = () => {},
  onChange = () => {},
}) => {
  const [daysOfMonth, setDaysOfMonth] = useState([]);
  const [date, setDate] = useState(initialState);

  useEffect(() => {
    if (value) {
      const year = value.year();
      const month = value.month();
      // const day = value.date()
      const day = null;
      setDate({ year, month, day });
    }

    const { days } = genCalendar(date.month, date.year);
    setDaysOfMonth(days);
  }, []);

  const decrementMonth = () => {
    const { month, year, ...rest } = date;

    let newYear = year;
    let newMonthNumber = month;

    if (newMonthNumber === 0) {
      newYear -= 1;
      newMonthNumber = 12;
    }

    newMonthNumber -= 1;

    const payload = {
      ...rest,
      day: null,
      year: newYear,
      month: newMonthNumber,
    };

    const { days } = genCalendar(payload.month, payload.year);

    setDate(payload);
    setDaysOfMonth(days);
  };

  const incrementMonth = () => {
    const { month, year, ...rest } = date;

    let newYear = year;
    let newMonthNumber = month;
    if (newMonthNumber === 11) {
      newYear += 1;
      newMonthNumber = -1;
    }
    newMonthNumber += 1;

    const payload = {
      ...rest,
      day: null,
      year: newYear,
      month: newMonthNumber,
    };

    const { days } = genCalendar(payload.month, payload.year);

    setDate(payload);
    setDaysOfMonth(days);
  };

  const handleSelect = (number) =>
    setDate((prevDate) => ({ ...prevDate, day: number }));

  const handleSubmit = () => {
    const { year, month, day } = date;
    onChange(moment(new Date(year, month, day)));
    onClose();
  };

  const clear = () => {
    onClose();
    onClear();
    setDate(initialState);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className={styles.calendar}>
        {/* HEADER */}
        <div className={styles.header}>
          <IconCalendar />
          <p className={styles.header_label}>Filtra por fecha de devolución</p>
        </div>
        {/* BODY */}
        <div className={styles.body}>
          {/* MONTHS */}
          <div className={styles.monthSelector}>
            <button onClick={decrementMonth}>
              <IconChevronLeft />
            </button>
            <p>
              {monthNames[date.month]} {date.year}
            </p>
            <button onClick={incrementMonth}>
              <IconChevronRight />
            </button>
          </div>
          {/* DAYS */}
          <div className={styles.days}>
            {dayNames.map((name) => (
              <div key={`dayName-${name}`}>
                <span>{name}</span>
              </div>
            ))}
            {daysOfMonth.map((number, i) => {
              if (typeof number === "object") {
                return <div key={`dayEmpty-${i}`} />;
              }
              return (
                <button
                  key={`dayNumber-${i}`}
                  onClick={() => handleSelect(number)}
                  className={
                    date.day === number
                      ? styles.dayNumber_active
                      : styles.dayNumber_inactive
                  }
                >
                  {number}
                </button>
              );
            })}
          </div>
          {/* BUTTONS */}
          <div className={styles.buttons}>
            <button className={styles.outline} onClick={clear}>
              Limpiar
            </button>
            <button
              disabled={!date.day}
              onClick={handleSubmit}
              className={styles.solid}
            >
              Aplicar filtro
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CustomCalendar;
